import { useState, useEffect } from 'react';
import { ROLES } from '../../utils/constants';
import { connect, useDispatch } from 'react-redux';
import { addChunkOnlinePresence } from '../../../redux/actions/user';
import useOnlineHook from '../../utils/useOnlineHook';
import { useHistory } from 'react-router';
import Avatar from '../Avatar';

const TopSection = ({ user }) => {
    useOnlineHook();

    const dispatch = useDispatch();
    const history = useHistory();

    const [creatorList, setCreatorList] = useState([]);

    const getCreatorList = async () => {
        await axios.get(`/api/users/creators`)
            .then((response) => {
                setCreatorList(response.data);
                const online = response.data.map(creator => {
                    if (creator.is_online) {
                        return creator.pu_id;
                    }
                }).filter(i => i);

                if (online.length > 0) {
                    dispatch(addChunkOnlinePresence(online));
                }
            })
            .catch((error) => {
                console.log({ error });
            });
    };

    useEffect(() => {
        if (user.role === ROLES.SU) {
            getCreatorList();
        }
    }, [user]);

    const handleGoToPu = (e, login) => {
        e.preventDefault();
        history.push(`/${login}`);
    };

    return <div className='top-section'>
        {
            user.role === ROLES.SU
                ? <div className="suggested-creators-container">
                    <h3>Suggested Creators</h3>
                    <div className="suggested-creators-list">
                        {creatorList && creatorList.map((creatorListItem, index) => (
                            <a
                                key={index}
                                href={`${process.env.MIX_APP_URL}/${creatorListItem.login}`}
                                onClick={(e) => handleGoToPu(e, creatorListItem.login)}
                            >
                                <div className="suggested-creators-item">
                                    <div className="suggested-creators-img no-stories">
                                        <Avatar
                                            size="71"
                                            pu={creatorListItem}
                                            story={false}
                                            bordered={true}
                                            showOnline
                                        />
                                    </div>
                                    <div className="suggested-creators-name">
                                        <p>{creatorListItem.login}</p>
                                    </div>
                                </div>
                            </a>
                        ))}
                    </div>
                </div>
                : null
        }
    </div>;
};

const mapStateToProps = state => ({
    user: state.user.user
});

export default connect(mapStateToProps)(TopSection);